import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IState {
    id: number | null,
    type: string,
    campaignName: string,
    createDate: string,
    isRefillModalOpen: boolean,
    idsSelectedCampaigns: Array<number>,
    isOpenMassAutofill: boolean
}

const initialState: IState = {
    id                  : null,
    type                : '',
    campaignName        : '',
    createDate          : '',
    isRefillModalOpen   : false,
    idsSelectedCampaigns: [],
    isOpenMassAutofill  : false
};

const updateIdsSelectedCampaigns = (ids: Array<number>, id: number, select = false) => {
    const currIds = new Set(ids);

    if(select) {
        currIds.add(id);
    } else {
        currIds.delete(id);
    }

    return [...currIds];
};

export const campaignsListSlice = createSlice({
    initialState,
    name    : 'campaigns-list',
    reducers: {
        reset       : () => initialState,
        toggleSelect: (state, action: PayloadAction<{ id: number, select: boolean }>) => {
            return {
                ...state,
                idsSelectedCampaigns: updateIdsSelectedCampaigns(
                    state.idsSelectedCampaigns, action.payload.id, action.payload.select
                )
            };
        },
        selectAll: (state, action: PayloadAction<{ ids: Array<number> }>) => (
            {
                ...state,
                idsSelectedCampaigns: action.payload.ids
            }
        ),
        toggleOpenMassAutofill: (state, action: PayloadAction<{ isOpen: boolean }>) => (
            {
                ...state,
                isOpenMassAutofill: action.payload.isOpen
            }
        ),
        getRefillBudgetData: (state, action: PayloadAction<{
            id: number | null,
            type: string,
            createDate: string,
            campaignName: string }>) => {
            return {
                ...state,
                ...action.payload
            };
        },
        resetRefillBudgetData: (state) => {
            return {
                ...state,
                id          : null,
                type        : '',
                createDate  : '',
                campaignName: ''
            };
        },
        toggleOpenRefillModal: (state, action: PayloadAction<{ isRefillModalOpen: boolean }>) => {
            return {
                ...state,
                isRefillModalOpen: action.payload.isRefillModalOpen
            };
        }
    }
});

export default campaignsListSlice.reducer;
